/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycSourceOfFundsObservationsDto } from '../../models/kyc-source-of-funds-observations-dto';

export interface SaveSourceOfFundsObservations$Params {
  processId: string;
      body: KycSourceOfFundsObservationsDto
}

export function saveSourceOfFundsObservations(http: HttpClient, rootUrl: string, params: SaveSourceOfFundsObservations$Params, context?: HttpContext): Observable<StrictHttpResponse<KycSourceOfFundsObservationsDto>> {
  const rb = new RequestBuilder(rootUrl, saveSourceOfFundsObservations.PATH, 'put');
  if (params) {
    rb.path('processId', params.processId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycSourceOfFundsObservationsDto>;
    })
  );
}

saveSourceOfFundsObservations.PATH = '/kyc/processes/{processId}/source-of-funds-observations';
